'use client'

import { MetricCard } from './dashboard.metric-card'
import { MetricData, TimePeriod } from './dashboard.types'
import { useAgentTradePerformance } from '@repo/services'

export const MetricsGrid = ({ timePeriod }: { timePeriod: TimePeriod }) => {
  const { data } = useAgentTradePerformance()

  const dataByTimePeriodOtcTrades = {
    '1d': data?.data?.otcTrades?.performance24h,
    '1w': data?.data?.otcTrades?.performance7d,
    '1M': data?.data?.otcTrades?.performance30d,
  }

  const dataByTimePeriodGeneral = {
    '1d': data?.data?.general?.performance24h,
    '1w': data?.data?.general?.performance7d,
    '1M': data?.data?.general?.performance30d,
  }

  const metrics: MetricData[] = [
    {
      title: 'dashboardAgent_revenue',
      valueNumber: dataByTimePeriodOtcTrades[timePeriod]?.otcIncome ?? 0,
      valueUnit: '',
      componentType: 'PaymentType',
      percentageChange:
        dataByTimePeriodOtcTrades[timePeriod]?.otcIncomeChangePercent ?? 0,
      showInfoIcon: true,
    },
    {
      title: 'dashboardAgent_profile_views',
      valueNumber: dataByTimePeriodGeneral[timePeriod]?.profileVisits ?? 0,
      valueUnit: 'dashboardAgent_visit',
      componentType: 'NumberUnit',

      percentageChange:
        dataByTimePeriodGeneral[timePeriod]?.profileVisitChangePercent ?? 0,
      showInfoIcon: true,
    },
    {
      title: 'dashboardAgent_registrations_count',
      valueNumber: dataByTimePeriodGeneral[timePeriod]?.newUserReferrals ?? 0,
      valueUnit: 'dashboardAgent_user',
      componentType: 'NumberUnit',

      percentageChange:
        dataByTimePeriodGeneral[timePeriod]?.newUserReferralsChangePercent ?? 0,
      showInfoIcon: true,
    },
    {
      title: 'dashboardAgent_trades',
      valueNumber: dataByTimePeriodOtcTrades[timePeriod]?.otcTrades ?? 0,
      valueUnit: 'dashboardAgent_trade',
      componentType: 'NumberUnit',

      percentageChange:
        dataByTimePeriodOtcTrades[timePeriod]?.otcTradesChangePercent ?? 0,
      showInfoIcon: true,
    },
    {
      title: 'dashboardAgent_traded_area',
      valueNumber: dataByTimePeriodOtcTrades[timePeriod]?.otcTokens ?? 0,
      valueUnit: '',
      componentType: 'ValueWithUnit',

      percentageChange:
        dataByTimePeriodOtcTrades[timePeriod]?.otcTokensChangePercent ?? 0,
      showInfoIcon: true,
    },
  ]
  return (
    <div
      className='grid 
  grid-cols-2 [&>*:first-child]:col-span-2 
  md:grid-cols-3 md:[&>*:first-child]:col-span-1 gap-0 sm:gap-lg'
    >
      {metrics.map((metric, index) => (
        <MetricCard
          key={index}
          title={metric.title}
          valueNumber={metric.valueNumber}
          componentType={metric.componentType}
          valueUnit={metric.valueUnit}
          timePeriod={timePeriod}
          percentageChange={metric.percentageChange}
          showInfoIcon={metric.showInfoIcon}
        />
      ))}
    </div>
  )
}
